"use strict";

import { authConstants, commonConstants, responseCodes } from "../_constants";

export const INITIAL_AUTH_STATE = {
     userProfileDetails: {},
     userDetails: null,
};

export function auth(state = INITIAL_AUTH_STATE, action) {
     switch (action.type) {
          /**
           * Customer login
           */

          case authConstants.AUTH_LOGIN_REQUEST:
               if (!action.payload.validateOtp) {
                    return {
                         ...state,
                         userProfileDetails: {
                              email: action.payload.email,
                              password: action.payload.password,
                         },
                    };
               }

               return {
                    ...state,
               };

          case authConstants.FORGOT_PASSWORD_RESET_PASSWORD_REQUEST:
               if (!action.payload.validateOtp) {
                    return {
                         ...state,
                         userProfileDetails: {
                              userId: action.payload.userId,
                              confirmPassword: action.payload.confirmPassword,
                              newPassword: action.payload.newPassword,
                              authToken: action.payload.authToken,
                         },
                    };
               }

               return {
                    ...state,
               };

          case authConstants.AUTH_LOGIN_COMPLETE:
               return {
                    ...state,
               };

          case authConstants.AUTH_USER_PROFILE_DEATAILS_COMPLETE:
               return {
                    ...state,
                    userProfileDetails: { ...action.payload.data },
               };

          case authConstants.PRE_REGISTRATION_COMPLETE:
               return {
                    ...state,
                    userProfileDetails: { ...action.payload.data },
               };

          case authConstants.USER_DETAILS_COMPLETE:
               return {
                    ...state,
                    userDetails: action.payload.data,
               };

          // case commonConstants.AJAX_ERROR:
          //     return INITIAL_AUTH_STATE;febaUserName
     }

     return state;
}
